import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * How much more the player has to actually play before the next nudge. Counted in playtime rather than
 * wall time, so a session left open in a background tab never buys the next prompt.
 */
export const NUDGE_COOLDOWN_MS = 6 * 60 * 1000

export const useLoginNudgeStore = defineStore(
    'login_nudge',
    () => {
        const desktopFooterTooltipTimesShown = ref(0)
        const nudgeCooldownLeftMs = ref(0)

        function markFooterDesktopTooltipShown() {
            desktopFooterTooltipTimesShown.value += 1
        }

        function markNudgeShown() {
            nudgeCooldownLeftMs.value = NUDGE_COOLDOWN_MS
        }

        function consumePlaytime(playedMs: number) {
            nudgeCooldownLeftMs.value = Math.max(nudgeCooldownLeftMs.value - playedMs, 0)
        }

        function isNudgeCoolingDown() {
            return nudgeCooldownLeftMs.value > 0
        }

        function reset() {
            desktopFooterTooltipTimesShown.value = 0
            nudgeCooldownLeftMs.value = 0
        }

        return {
            desktopFooterTooltipTimesShown,
            nudgeCooldownLeftMs,
            markFooterDesktopTooltipShown,
            markNudgeShown,
            consumePlaytime,
            isNudgeCoolingDown,
            reset,
        }
    },
    {
        persist: {
            key: 'login_nudge',
            pick: ['desktopFooterTooltipTimesShown', 'nudgeCooldownLeftMs'],
        },
    },
)
